import { Hubspot, HubspotServices, SalesforceServices } from '@clearkit/icons';
import { CKActionMenu, CKButton, CKDropdownChevron, CKPopover } from 'clearkit';
import { Link } from 'react-router-dom';

import { settingsRoutes } from '~/components/settings/settingsRoutes';
import { useEntitlements } from '~/hooks/account';

import { useCRMConnectors } from '../../hooks/useCRMConnectors';
import { useCRMLabel } from '../../hooks/useCRMLabel';
import {
  ImplementationCard,
  ImplementationCardWrapperProps,
} from '../ImplementationCard';
import { LoadingCard } from './LoadingCard';

const iconClasses = 'w-4 h-4';

const ActionMenu = () => (
  <CKActionMenu>
    <CKActionMenu.Item
      as={Link}
      leftIcon={<SalesforceServices className={iconClasses} />}
      to="/enrichment/salesforce"
    >
      Connect to Salesforce
    </CKActionMenu.Item>
    <CKActionMenu.Item
      as={Link}
      leftIcon={<HubspotServices className={iconClasses} />}
      to="/enrichment/hubspot"
    >
      Connect to Hubspot
    </CKActionMenu.Item>
  </CKActionMenu>
);

export const ConnectCRM = ({
  forceVisibility,
}: ImplementationCardWrapperProps) => {
  const { hasAccessSettingsConnectedServices } = useEntitlements();
  const { defaultConnector, loading } = useCRMConnectors();
  const isConnected = defaultConnector;
  const { crmLabel } = useCRMLabel();

  if (loading) return <LoadingCard />;
  if (isConnected && !forceVisibility) return null;

  return (
    <ImplementationCard progress={isConnected ? 100 : 0}>
      <ImplementationCard.Heading>
        Connect {crmLabel}
      </ImplementationCard.Heading>
      <ImplementationCard.Description>
        Perform a data test, enrich company and contact data from {crmLabel},
        and unlock powerful segmentation and workflows with account, contact,
        and lead data.
      </ImplementationCard.Description>
      <ImplementationCard.Footer>
        {hasAccessSettingsConnectedServices ? (
          <CKButton
            as={Link}
            leftIcon={<Hubspot />}
            to={settingsRoutes.configureHubspot}
            variant="bold"
            variantColor="green"
          >
            Connect HubSpot
          </CKButton>
        ) : (
          <CKPopover popover={<ActionMenu />}>
            <CKButton
              rightIcon={<CKDropdownChevron />}
              variant="bold"
              variantColor="green"
            >
              Connect your CRM
            </CKButton>
          </CKPopover>
        )}
        <CKButton
          as="a"
          href="https://clearbit.com/integrations"
          variant="tertiary"
          variantColor="blue"
        >
          Learn more
        </CKButton>
      </ImplementationCard.Footer>
    </ImplementationCard>
  );
};
